import { render, staticRenderFns } from "./StartTrainExam.vue?vue&type=template&id=45adcd4c&scoped=true&"
import script from "./StartTrainExam.vue?vue&type=script&lang=js&"
export * from "./StartTrainExam.vue?vue&type=script&lang=js&"
import style0 from "./StartTrainExam.vue?vue&type=style&index=0&id=45adcd4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45adcd4c",
  null
  
)

export default component.exports